// Gestion du thème clair/sombre.
// Le choix est persisté dans localStorage et appliqué via l'attribut
// data-theme sur <html>, exploité par les variables CSS de src/styles/index.css.
const STORAGE_KEY = 'fd_theme';
const THEMES = ['light', 'dark'];

export function getTheme() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (THEMES.includes(stored)) return stored;
  } catch {}
  return 'light';
}

export function applyTheme(theme) {
  const value = THEMES.includes(theme) ? theme : 'light';
  const root = document.documentElement;
  root.setAttribute('data-theme', value);
  // Garde la couleur de la barre système cohérente.
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', value === 'dark' ? '#0e1512' : '#0f5132');
  return value;
}

export function setTheme(theme) {
  const value = applyTheme(theme);
  try { localStorage.setItem(STORAGE_KEY, value); } catch {}
  return value;
}

// À appeler tôt au démarrage pour éviter le flash de couleurs.
export function initTheme() {
  return applyTheme(getTheme());
}
